import { makeStyles } from "@material-ui/core";

export default makeStyles(
  {
    actions: {
      border: "none"
    },
    closeIcon: {
      padding: 5,
      position: "absolute",
      right: 0,
      top: 0
    },
    content: {
      paddingBottom: 0,
      paddingTop: 0
    },
    dialog: {
      maxWidth: 400,
      position: "absolute",
      right: 0,
      top: 0
    },
    noThanksButton: {
      "& .MuiButton-label": {
        color: "#0030FF",
        fontSize: "0.875rem",
        fontWeight: 600
      },
      marginRight: 10
    },
    saveAccountButton: {
      "& .MuiButton-label": {
        color: "#FFFFFF",
        fontSize: "0.875rem",
        fontWeight: 600,
        padding: 2
      },
      "&:hover": {
        backgroundColor: "#ACCAFF"
      },
      "&:hover .MuiButton-label": {
        color: "#0030FF"
      },
      backgroundColor: "#0030FF"
    },
    title: {
      border: "none",
      fontWeight: "bold"
    },
    titleText: {
      fontSize: "1em",
      fontWeight: 600
    },
    titleWrapper: {
      position: "relative"
    }
  },
  {
    name: "SaveAccountDialog"
  }
);
